module.exports = __webpack_public_path__ + "static/media/communications.87ca6128.png";